export const stateName = 'userStats';